'use strict';

import { Entity } from '../Entity';
import { Agency } from './Agency';

export class AgencyNotificationPreference extends Entity {
  protected id: number;
  protected agency;
  protected event;
  protected method;
  protected data;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;
    this.event = data.event;
    this.method = data.method;
    this.data = data.data;

    if (data.agency) {
      this.agency = data.agency;
    }
  }

  public getId() {
    return this.id;
  }

  public getEvent() {
    return this.event;
  }

  public setEvent(event) {
    this.event = event;
    return this;
  }

  public getMethod() {
    return this.method;
  }

  public setMethod(method) {
    this.method = method;
    return this;
  }

  public getData() {
    return this.data;
  }

  public setData(data) {
    this.data = data;
    return this;
  }
}
